export default "__VITE_ASSET__C8w4iKc2__"